import $ from "jquery";
export default class AnchorScroll {
    static mount() {
        $('a[href*="#"]')
            .not('[href="#"]')
            .not('[href="#0"]')
            .on("click", function (event) {
            let aTag = this;
            if (location.pathname.replace(/^\//, "") ==
                aTag.pathname.replace(/^\//, "") &&
                location.hostname == aTag.hostname) {
                var target = $(aTag.hash);
                target = target.length
                    ? target
                    : $("[name=" + aTag.hash.slice(1) + "]");
                if (null !== target && target.length) {
                    event.preventDefault();
                    let offset = target.offset();
                    if (offset) {
                        window.location.hash = aTag.hash;
                        $("html, body").animate({
                            scrollTop: offset.top - 160,
                        }, 1000, function () {
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) {
                                return false;
                            }
                            else {
                                $target.attr("tabindex", "-1");
                                $target.focus();
                            }
                        });
                    }
                }
            }
        });
    }
}
